export enum Steps {
    Content = 0,
    Category = 1,
    Options = 2
}